import React from "react";

const Italic = ({ customComponent, onChange, isActive, isDisabled }) => {
	const toggleItalic = () => {
		if (onChange) onChange();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={toggleItalic}
				title="Italic"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fas fa-italic" />}
			</button>
		</>
	);
};

export default Italic;
